import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vsl/a")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
  component: () => null,
});
